import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "@/views/Dashboard.vue";
import Tables from "@/views/Tables.vue";
import Billing from "@/views/Billing.vue";
import Log from "@/views/Log.vue";
import LiveLog from "@/views/LiveLog.vue";
import SwitchList from "@/views/SwitchList.vue";
import VirtualReality from "@/views/VirtualReality.vue";
import ProfileTemplate from "../views/ProfileTemplate.vue";
import Rtl from "@/views/Rtl.vue";
import SignIn from "@/views/SignIn.vue";
import SignUp from "@/views/SignUp.vue";
import Login from "@/views/Login.vue";
import Register from "@/views/Register.vue";
import SendEmail from "../views/SendEmail.vue";
import ResetPassword from "../views/ResetPassword.vue";
import Profile from "@/views/Profile.vue";
import Graph from "@/views/Graph.vue";
import SwitchGraph from "@/views/SwitchGraph.vue";
import Users from "../views/Users.vue";
import Roles from "../views/Roles.vue";
import OltDataPort from "../views/OltDataPort.vue";
import OltPort from "../views/OltPort.vue";
import OltList from "../views/OltList.vue";
import Share from "../views/Share.vue";
import AddOlt from "../views/AddOlt.vue";
import EditOlt from "../views/EditOlt.vue";
import ShareOlt from "../views/ShareOlt.vue";
import store from "/src/store";
import guest from "../middlewares/guest.js";
import auth from "../middlewares/auth.js";
import Permissions from "../views/Permissions.vue";
import RolePermissions from "../views/RolePermissions.vue";
import Branch from "../views/Branch.vue";
import Ping from "../views/Ping.vue";
import PopMonitor from "../views/PopMonitor.vue";
import PopArea from "../views/PopArea.vue";
import Service from "../views/Service.vue";
import OltDetails from "../views/OltDetails.vue";
import SwitchDetails from "../views/SwitchDetails.vue";
import PopList from "../views/PopList.vue";
import PopLog from "../views/PopLog.vue";
import OnuDownScanner from "../views/OnuDownScanner.vue";
import DownCount from "../views/DownCount.vue";
import getProfileCheck from "@/services/check-profile.service";

function middlewarePipeline(context, middleware, index) {
  const nextMiddleware = middleware[index];

  if (!nextMiddleware) {
    return context.next;
  }

  return () => {
    const nextPipeline = middlewarePipeline(context, middleware, index + 1);
    nextMiddleware({ ...context, next: nextPipeline });
  };
}

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiredPermission: "2008" }
  },
  {
    path: "/tables",
    name: "Tables",
    component: Tables,
  },
  {
    path: "/package-list",
    name: "Package List",
    component: Billing,
    meta: { requiredPermission: "2001" }
  },
  {
    path: "/log-list",
    name: "Log",
    component: Log,
    meta: { requiredPermission: "2002" }
  },
  {
    path: "/share-olt",
    name: "Share",
    component: Share,
    meta: { requiredPermission: "2005" }
  },
  {
    path: "/live-log-list",
    name: "LiveLog",
    component: LiveLog,
  },
  {
    path: "/switch-list",
    name: "SwitchList",
    component: SwitchList,
    meta: { requiredPermission: "2004" }
  },
  {
    path: "/onu-down-count",
    name: "DownCount",
    component: DownCount,
    meta: { requiredPermission: "2021" }
  },
  {
    path: "/onu-down-scanner",
    name: "OnuDownScanner",
    component: OnuDownScanner,
    meta: { requiredPermission: "2020" }
  },
  {
    path: "/ping",
    name: "Ping",
    component: Ping,
    meta: { requiredPermission: "2012", hideLayout: true }
  },
  {
    path: "/pop-monitor",
    name: "Pop Monitor",
    component: PopMonitor,
    meta: { requiredPermission: "2014" }
  },
  {
    path: "/pop-list",
    name: "Pop List",
    component: PopList,
    meta: { requiredPermission: "2015" }
  },
  {
    path: "/pop-log",
    name: "Pop Log",
    component: PopLog,
    meta: { requiredPermission: "2011" }
  },
  {
    path: "/pop-area",
    name: "Pop Area",
    component: PopArea,
    meta: { requiredPermission: "2013" }
  },
  {
    path: "/service",
    name: "Service",
    component: Service,
    meta: { requiredPermission: "2016" }
  },
  {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
  },
  {
    path: "/profileTemplate",
    name: "ProfileTemplate",
    component: ProfileTemplate,
  },
  {
    path: "/rtl-page",
    name: "Rtl",
    component: Rtl,
  },
  {
    path: "/sign-in",
    name: "Sign In",
    component: SignIn,
  },
  {
    path: "/sign-up",
    name: "Sign Up",
    component: SignUp,
    meta: {
      middleware: [guest],
    },
  },
  {
    path: "/graph/:pppoe",
    name: "Graph",
    component: Graph,
  },
  {
    path: "/switch-graph/:id/:olt?",
    name: "SwitchGraph",
    component: SwitchGraph,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      middleware: [guest],
    },
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: {
      middleware: [guest],
    },
  },
  {
    path: "/password/email",
    name: "SendEmail",
    component: SendEmail,
    meta: {
      middleware: [guest],
    },
  },
  {
    path: "/password/reset",
    name: "ResetPassword",
    component: ResetPassword,
    meta: {
      middleware: [guest],
    },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: { requiredPermission: "2000" }
  },
  {
    path: "/roles",
    name: "Roles",
    component: Roles,
    meta: { requiredPermission: "2000" }
  },
  {
    path: "/roles-permission",
    name: "RolePermissions",
    component: RolePermissions,
    meta: { requiredPermission: "2000" }
  },
  {
    path: "/permissions/:id?/:user_id?",
    name: "Permissions",
    component: Permissions,
  },
  {
    path: "/branch",
    name: "Branch",
    component: Branch,
    meta: { requiredPermission: "2000" }
  },
  {
    path: "/olt-data-ports",
    name: "OltDataPort",
    component: OltDataPort,
    meta: { requiredPermission: "2007" }
  },
  {
    path: "/olt-ports",
    name: "OltPort",
    component: OltPort,
    meta: { requiredPermission: "2003" }
  },
  {
    path: "/olt-list",
    name: "OltList",
    component: OltList,
    meta: { requiredPermission: "2006" }
  },
  {
    path: "/olt-list/:id",
    name: "OltDetails",
    component: OltDetails,
  },
  {
    path: "/switch-list/:id",
    name: "SwitchDetails",
    component: SwitchDetails,
  },
  {
    path: "/add-olt",
    name: "AddOlt",
    component: AddOlt,
  },
  {
    path: "/edit-olt/:edit_id",
    name: "EditOlt",
    component: EditOlt,
  },
  {
    path: "/share-olt/:edit_id",
    name: "ShareOlt",
    component: ShareOlt,
  },
  {
    path: "/forbidden",
    name: "Forbidden",
    component: () => import("@/views/Forbidden.vue")
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: Dashboard, // or a NotFound component
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const element = document.querySelector(to.hash);
          if (element) {
            resolve({
              el: to.hash,
              behavior: "smooth",
            });
          } else {
            resolve({ top: 0 });
          }
        }, 2000); // Add a short delay to ensure the element is rendered
      });
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
  linkActiveClass: "active",
});

// eslint-disable-next-line no-unused-vars
router.beforeEach(async (to, from, next) => {
  // Fetch permissions from API
  let permissions = [];
  try {
    const response = await getProfileCheck.getProfileCheck();
    permissions = response?.user_role?.menus || [];
  } catch (e) {
    // Ignore errors, permissions will be empty
  }

  // Check for required permission
  const requiredPermission = to.meta.requiredPermission;
  if (requiredPermission) {
    const hasPermission = permissions.find(
      (item) => item.code === requiredPermission && item.active === true
    );
    if (!hasPermission) {
      // Redirect to Forbidden page
      return next({ name: "Forbidden" });
    }
  }

  const context = {
    to,
    from,
    next,
    store,
  };

  if (!to.meta.middleware) {
    return auth({ ...context, next });
  }

  const middleware = to.meta.middleware;
  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1),
  });
});

export default router;
